import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => {
  const topListPropsDefault = {
    display: 'flex',
    justifyContent: 'flex-end',
    '& > div': {
      display: 'flex',
      alignItems: 'center',
    },
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  };

  return {
    topList: { ...topListPropsDefault },
    topListWithTotal: {
      ...topListPropsDefault,
      justifyContent: 'space-between',
      marginBottom: '20px',
    },
    labelValue: {
      fontSize: '16px',
      paddingLeft: '16px',
    },
    mainValue: {
      display: 'inline-block',
      marginLeft: '10px',
      fontWeight: 700,
    },
  };
});

export default useStyles;
